var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAccessManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.228 20.063l1.705 1.705h-3.164A5.775 5.775 0 0116.999 16a5.775 5.775 0 015.77-5.768h3.164l-1.705 1.705 1.414 1.414 4.119-4.119-4.12-4.119-1.413 1.414 1.705 1.705h-3.164a7.768 7.768 0 00-6.77 3.968 7.767 7.767 0 00-6.767-3.968H6.068l1.705-1.705-1.414-1.414-4.12 4.12 4.12 4.118 1.414-1.414-1.705-1.705h3.164A5.774 5.774 0 0115 16a5.775 5.775 0 01-5.768 5.768H6.068l1.705-1.705-1.414-1.414-4.12 4.12 4.12 4.118 1.414-1.414-1.705-1.705h3.164A7.768 7.768 0 0016 19.8a7.77 7.77 0 006.769 3.97h3.164l-1.705 1.704 1.414 1.414 4.119-4.119-4.12-4.119-1.413 1.414z",
    fill: props.color
  })));
}

export default SvgIconAccessManagement;